// extracted by mini-css-extract-plugin
module.exports = {"procedureName":"styles_procedureName__Q5zYV","colMin":"styles_colMin__1-n_d","colCheckbox":"styles_colCheckbox__3oqEv"};